import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/AD';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

// 取得先前通知方式變更記錄
export function getInfoAD() {
    return get(`${url}/info`);
}

/**
 * sumbit
 * @param {Object} data
 */
export function submitAD(data) {
    return post(`${url}/submit`, data, { ...options, repeatRequestCancel: true });
}
